import styled from "styled-components";
import { SubTitle, Text } from "../../common/texts";

export const Wrapper = styled.section`
  background-color: #fffdf6;
  padding: 75px var(--p-container);

  @media (max-width: 768px) {
    padding: 45px var(--p-container);
  }
`;

export const Inner = styled.div`
  max-width: 1150px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 55px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 32px;
    text-align: center;
  }
`;

export const TextCol = styled.div`
  flex: 1 1 50%;

  ${SubTitle} {
    position: relative;
    margin-bottom: 24px;
    line-height: 1.4;

    &::after {
      content: "";
      display: block;
      width: 64px;
      height: 4px;
      margin-top: 16px;
      background: ${({ theme }) => theme.colors.primary};
      border-radius: 4px;
    }
  }

  ${Text} {
    line-height: 1.95;
    color: #444;
    text-align: left;
  }

  @media (max-width: 900px) {
    ${SubTitle}::after {
      margin-left: auto;
      margin-right: auto;
    }
    ${Text} {
      text-align: center;
    }
  }
`;

export const ImageCol = styled.div`
  flex: 1 1 50%;

  img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 18px;
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18);
  }
`;
